import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { accountsApi, accountsReducers } from '@accounts/store/store';
import { authMiddlewares, authReducers } from '@auth/store/store';
import { customersApi, customersReducers } from '@clients/store/store';
import {
  configurationReducers,
  configurationApi,
} from '@configuration/store/store';
import { exchangeReducers, exchangeApi } from '@exchange/store/store';
import { dashboardReducers, dashboardApi } from '@dashboard/store/store';
import {
  administrationReducers,
  administrationApi,
} from '@administration/store/store';
import {
  reducers as messagesReducer,
  messagesApi,
} from '@messaging/store/store';
import {
  notificationCenterReducers,
  notificationCenterApi,
} from '@notifications/store/store';
import { reducers as reportsReducers, reportsApi } from '@reports/store/store';
import { amlApi, amlKycReducers } from '@aml/store/store';
import {
  transactionsApi,
  transactionsReducers,
} from '@transactions/store/store';
import api from '../api/api';
import RootComponentReducer from './slice';
import { rootComponentApi } from './service';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  ...authReducers,
  ...accountsReducers,
  ...customersReducers,
  ...transactionsReducers,
  ...amlKycReducers,
  ...configurationReducers,
  ...administrationReducers,
  ...reportsReducers,
  ...messagesReducer,
  ...exchangeReducers,
  ...dashboardReducers,
  ...notificationCenterReducers,
  root: RootComponentReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      rootComponentApi.middleware,
      authMiddlewares.middleware,
      accountsApi.middleware,
      ...customersApi,
      transactionsApi.middleware,
      ...amlApi,
      ...configurationApi,
      ...administrationApi,
      reportsApi.middleware,
      messagesApi.middleware,
      exchangeApi.middleware,
      ...dashboardApi,
      notificationCenterApi.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;
